import {Coordinates} from "@/event/calendar/Shapes.ts";


export function isTouchEvent(e: MouseEvent | TouchEvent | PointerEvent): e is TouchEvent {
	return typeof TouchEvent !== "undefined" && e instanceof TouchEvent;
}

export function localCoord(e: MouseEvent | TouchEvent | PointerEvent, elm: HTMLElement): Coordinates {
	const rect = elm.getBoundingClientRect();
	let clientX: number, clientY: number;

	if (isTouchEvent(e)) {
		const touch = e.touches[0] ?? e.changedTouches[0];
		if (!touch) {
			return { x: 0, y: 0 }; // fallback if no touch points
		}
		clientX = touch.clientX;
		clientY = touch.clientY;
	} else {
		clientX = e.clientX;
		clientY = e.clientY;
	}

	return {
		x: clientX - rect.left,
		y: clientY - rect.top,
	};
}